 <template>
  <v-dialog
    v-model="dialog"
    max-width="650"
    persistent
  >
    <v-card class="pt-2 pl-0 pr-0">

      <v-card-title
        class="headline-6"
        :class="{'subtitle-2':$vuetify.breakpoint.xs}"
        style="word-break: normal; !important"
      >
        {{(hub && !hub.id)?$vuetify.lang.t('$vuetify.NOVA_HUB'):
        $vuetify.lang.t('$vuetify.ATUALIZANDO_HUB')}}
      </v-card-title>

      <v-form
        ref="form"
        lazy-validation
      >

        <v-row class="ma-0  justify-center mb-n3">

          <v-col
            cols="6"
            class="ml-n2 mr-6"
          >
            <v-row>
              <span class=" text-right subtitle-2 font-weight-bold grey--text text--lighten-1">
                {{$vuetify.lang.t('$vuetify.NOME')}}:</span>
            </v-row>
            <v-row md="2">
              <v-text-field
                v-model.trim="hub.nome"
                dense
                single-line
                solo
                max-width="200"
                :rules="rules"
              ></v-text-field>
            </v-row>
          </v-col>

          <v-col
            cols="4"
            class="mr-n2"
          >
            <v-row>
              <span class=" text-right subtitle-2 font-weight-bold grey--text text--lighten-1">
                {{$vuetify.lang.t('$vuetify.SIGLA')}}:</span>
            </v-row>
            <v-row md="2">
              <v-text-field
                v-model.trim="hub.sigla"
                dense
                single-line
                solo
                max-width="200"
                :rules="rules"
              ></v-text-field>
            </v-row>
          </v-col>

        </v-row>

        <v-row class="ma-0 d-flex justify-center mb-n3">

          <v-col
            cols="5"
            class="ml-n2 mr-6"
          >
            <v-row>
              <span class=" text-right subtitle-2 font-weight-bold grey--text text--lighten-1">
                {{$vuetify.lang.t('$vuetify.BANDA')}}:</span>
            </v-row>
            <v-row md="2">
              <v-text-field
                v-model.trim="hub.banda"
                dense
                single-line
                solo
                max-width="200"
                :rules="rules"
              ></v-text-field>
            </v-row>
          </v-col>

          <v-col
            cols="5"
            class="mr-n2"
          >
            <v-row>
              <span class=" text-right subtitle-2 font-weight-bold grey--text text--lighten-1">
                {{$vuetify.lang.t('$vuetify.TECNOLOGIA')}}:</span>
            </v-row>
            <v-row md="2">
              <v-text-field
                v-model.trim="hub.tecnologia"
                dense
                single-line
                solo
                max-width="200"
                :rules="rules"
              ></v-text-field>
            </v-row>
          </v-col>

        </v-row>

        <v-row class="ma-0 d-flex justify-center mb-n3">

          <v-col
            cols="8"
            class="pr-7 pl-7"
          >
            <v-row>
              <span class=" text-right subtitle-2 font-weight-bold grey--text text--lighten-1">
                {{$vuetify.lang.t('$vuetify.DESCRICAO')}}:</span>
            </v-row>
            <v-row md="2">
              <v-text-field
                v-model.trim="hub.descricao"
                dense
                single-line
                solo
                max-width="200"
                :rules="rules"
              ></v-text-field>
            </v-row>
          </v-col>

          <v-col
            cols="3"
            class="pr-7 pl-7"
          >
            <v-checkbox
                  :input-value="active"
                  v-model="hub.migracao"
                  color="blue darken-2"
                  dense
                  :value="active"
                  class="mt-6 ml-n3"
                  :label="$vuetify.lang.t('$vuetify.MIGRACAO')"
                ></v-checkbox>

          </v-col>

        </v-row>
      </v-form>

      <v-divider></v-divider>

      <v-card-actions>
        <v-lazy
          :options="{threshold: .6}"
          transition="slide-x-transition"
        >
          <span
            class="ml-4 caption red--text"
            v-show="showHubAlreadyExists"
          >{{$vuetify.lang.t('$vuetify.JA_EXISTE_HUB')}}</span>
        </v-lazy>

        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-2"
          text
          @click="$refs.form.resetValidation(); $refs.form.reset(); close()"
        >
          {{$vuetify.lang.t('$vuetify.CANCELAR')}}
        </v-btn>
        <v-btn
          color="blue darken-2"
          text
          @click="$refs.form.validate(); send(hub)"
          :loading="isLoading"
        >
          {{$vuetify.lang.t('$vuetify.ENVIAR')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {

  components: {

  },
  props: {
    close: Function,
    dialog: Boolean,
    color: String,
    send: Function,
    hub: Object,
    isLoading: Boolean,
    showHubAlreadyExists: Boolean,
  },
  methods: {

  },
  data () {
    return {
      rules: [v => v && v.trim().length >= 1 || this.$vuetify.lang.t('$vuetify.CAMPO_OBRIGATORIO'),],
    }
  },
  created: function () {

    this.$root.$on('invalidateFields', () => {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
    })
  }
};
</script>